import React, { useEffect, useState } from 'react';
import { Container, Spinner, Alert } from 'react-bootstrap';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { exchangeImpersonationCode } from '../../store/slices/authSlice';
import { useAppDispatch } from '../../store/hooks';

const ImpersonatePage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [fatal, setFatal] = useState<string | null>(null);

  useEffect(() => {
    const code = searchParams.get('code');
    if (!code) {
      setFatal('Ссылка не содержит код. Запросите новую ссылку в админке.');
      return;
    }

    let cancelled = false;

    (async () => {
      try {
        await dispatch(exchangeImpersonationCode(code)).unwrap();
        if (!cancelled) {
          navigate('/products', { replace: true });
        }
      } catch (err: unknown) {
        if (!cancelled) {
          setFatal(typeof err === 'string' ? err : 'Не удалось войти по ссылке');
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [dispatch, navigate, searchParams]);

  return (
    <Container className="py-5 d-flex flex-column align-items-center justify-content-center" style={{ minHeight: '60vh' }}>
      {!fatal && (
        <>
          <Spinner animation="border" className="mb-3" role="status" />
          <p className="text-muted mb-0">Выполняется вход…</p>
        </>
      )}
      {fatal && (
        <Alert variant="danger" className="w-100" style={{ maxWidth: 480 }}>
          {fatal}
        </Alert>
      )}
    </Container>
  );
};

export default ImpersonatePage;
